// extracted by mini-css-extract-plugin
export default {"breadcrumb":"CsCbn","breadcrumb-item":"_0d4JX","active":"_0dfkV"};